import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  background-color: ${({ theme }) => `${theme.colors.semantic.attention}1C`};
  color: ${({ theme }) => theme.colors.semantic.attention};
  border: 2px solid ${({ theme }) => theme.colors.semantic.attention};
  border-color: ${({ theme }) => theme.colors.semantic.attention};
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 10px;
  min-width: 300px;
  height: auto;
`

export const Title = styled.p`
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 5px;
`

export const Message = styled.p`
  font-weight: normal;
  font-size: 14px;
  margin: 0;
`
